module.exports = __webpack_public_path__ + "static/ucsfLogo-cc30f0ddb6d05729fa917bdc69a52e0e.png";